import { ScreenerFieldInputType } from '../interfaces';

export const isNumericRangeInputType = (inputType: string) =>
  inputType === ScreenerFieldInputType.DECIMAL_RANGE ||
  inputType === ScreenerFieldInputType.INTEGER_RANGE ||
  inputType === ScreenerFieldInputType.PERCENTAGE_RANGE;
